import React, { useState, useEffect } from "react";
import { Container, Col, Row, Accordion, Button, Image, Modal } from "react-bootstrap";
import Ripples from 'react-ripples'
import { NavLink, useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import trash2 from '../assets/img/trash-2.jpg';
import trash3 from '../assets/img/trash-3.jpg';
import trash4 from '../assets/img/trash-4.jpg';
import score from '../assets/icons/score.png';
import orders from '../assets/icons/order.png'
import OrderForm from "./OrderForm";
import { apiUrl } from "../commons/inFormTypes";
import { ProfileUrl } from "../commons/IPAddress";
import { IPUrl } from "../commons/IPAddress";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo1 from '../assets/img/alert8.png'
import { Rating } from 'react-simple-star-rating'


function Dashboard() {
  const [state1, setState1] = useState(false);
  const [protest, setProtest] = useState();
  const [rating, setRating] = useState(0)
  const [check, setCheck] = useState();
  const [order, setOrder] = useState()
  const [delivery, setDelivery] = useState()
  const [radioText, setRadioText] = useState("");
  const [radioItem, setRadioItem] = useState(0);
  const [show, setShow] = useState(false);
  const [Stchange, setstchange] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const [seenProtest, setSeenProtest] = useState([]);
  const [listOredr, setListOredr] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const [address, setAddress] = useState(0);
  const navigate = useNavigate()



  const handleClose = () => {
    setShow(false);
    setDelivery("");
    setCheck("");
  }


  const handleShow = (val, orderId) => {
    setShow(true);
    setOrder(orderId);
    setDelivery(val);
  }

  const handleRating = (rate) => {
    setRating(rate)
  }

  const handleShowAccess = (val) => {
    setShow(true);
    setCheck("1");
    setProtest(val);
  }

  const handleShowProtest = (val) => {
    setShow(true);
    setCheck("2");
    setProtest(val);

  }


  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {      
      const axios = require("axios");
      axios
        .post(apiUrl + "Get_ListOrders", {
          code: 1,
          TokenId: userToken,
          Code_Meli: ""
        })
        .then((res) => {                       
          if (res.data.result === "true") {     
            if(res.data.data.length > 0) {
              if(res.data.data[0].Stage_Tittle.includes("در انتظار"))
                setState1(true) 
                else      
                setState1(false)             
            }          
            else 
             setState1(false)              
            setSeenFile(res.data.data);
            setSeenProtest(res.data.data_Confirm);
            if(state1===true) {
              setTimeout(() => {
                if(Stchange==false)
                setstchange(true)
                else
                setstchange(false)
              }, 180000);
            }
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }

    // const price = 1470005555;
    // let dollarUSLocale = Intl.NumberFormat('en-US').format(price)
    // setPerson(dollarUSLocale)
    // console.log(dollarUSLocale)
  }, [Stchange]);

  const toggleHandler = (value) => {
    setAddress(value)
    if (isOpen) setIsOpen(false);
    else setIsOpen(true);
  };

  const detailHandler = (index, val) => {
    const axios = require("axios");
    axios
      .post(apiUrl + "Get_DetailsOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: ""
      })

      .then((res) => {
        if (res.data.result === "true") {
          setListOredr(res.data.data);
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const deleteHandler = (val) => {
    if (radioItem === 0) {
      toast.error("لطفا یکی از گزینه ها را انتخاب نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    } else {
      setShow(false);
      const axios = require("axios");
      axios
        .post(apiUrl + "DeleteOrders", {
          reasonI_Id: radioItem,
          reason: radioText,
          code: val,
          TokenId: userToken,
          Code_Meli: ""
        })

        .then((res) => {
          setDelivery("");
          if (res.data.result === "true") {
            if (Stchange) {
              setstchange(false)
            } else {
              setstchange(true)
            }
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }


  }

  const RadioHandlerChange = (val, txt) => {
    setRadioItem(val);
    setRadioText(txt);
  }
  
  const handleProtest = () => {
    const axios = require("axios");
    axios
      .post(apiUrl + "Insert_protest", {
        Orderid: protest,
        TokenId: userToken,
      })

      .then((res) => {
        if (res.data.result === "true") {
          if (Stchange) {
            setstchange(false)
          } else {
            setstchange(true)
          }
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setShow(false);
          setDelivery("");
          setCheck("");
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const handleComment = (val) => {
    if(val === 0 ) {
      toast.error("لطفا به عملکرد راننده  امتیاز دهید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "Insert_Comment", {
          Rate: val,
          Orderid: protest,
          TokenId: userToken,
        })
  
        .then((res) => {
          if (res.data.result === "true") {
            if (Stchange) {
              setstchange(false)
            } else {
              setstchange(true)
            }
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setShow(false);
            setDelivery("");
            setCheck("");
            setRating(0);
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }




  return (
    <div>
      <main>
        <div className="pt-3">
          <Container className="m-auto">
            <Row className="justify-content-center mb-3">
              <Col xs={12} md={10} className="mt-3">
                <Row className="justify-content-center  g-4">
                  <Col xs={12} style={{ direction: "ltr" }} className="my-3">
                    <Carousel
                      autoPlay={true}
                      showThumbs={false}
                      infiniteLoop={true}
                      interval={3000}
                    >
                      <div>
                        <img className="rgc-carousel" src={trash2} alt="trash2" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={trash3} alt="trash3" />
                      </div>
                      <div>
                        <img className="rgc-carousel" src={trash4} alt="trash4" />
                      </div>
                    </Carousel>
                  </Col>
 
                  {seenProtest.map((data, index) => {                   
                    return (                    
                      <Col xs={12}  key={index} className="rgc-orderreg-items rgc-score-body text-center sub-side">

                        <i className="far fa-hand-point-left fa-beat"></i>
                        <span className="px-2">{data.Comment}</span>
                        <i className="far fa-hand-point-right fa-beat"></i>

                        <Row className="justify-content-center my-2">
                          <Col xs={5} md={4} >
                            <Button className="rgc-driver-btn rgc-driver-btn-remove"
                              onClick={() => handleShowProtest(data.OrderId)}
                            >
                              اعتراض دارم
                            </Button>
                          </Col>

                          <Col xs={5} md={4}>
                            <Button className="rgc-driver-btn rgc-driver-btn-edit"
                              onClick={() => handleShowAccess(data.OrderId)}
                            >
                              موافقم
                            </Button>
                          </Col>
                        </Row>
                      </Col>                 
                    )
                  })
                }

                  <Col xs={12} className="sub-side">
                    <div className="d-flex rgc-title">
                      <div className="rgc-title-point"></div>
                      <h4>سفارشات <span>در حال پذیرش</span></h4>
                    </div>
                  </Col>

                  <Col xs={12} className="mt-3">
                    <Accordion defaultActiveKey="0" flush >
                      {seenFile.length === 0 ?
                        <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                          <span>سفارش موجود نیست</span>
                        </Col>
                        :
                        seenFile.map((data, index) => {
                          return (
                            <Accordion.Item className="rgc-driver-card"
                              key={index}
                              eventKey={index} onClick={() => detailHandler(index, data.Order_Id)}>
                              <Accordion.Header>

                                <Row className="juustify-content-start rgc-driver-info w-100 g-0">
                                  <Col xs={5} md={6} className="rgc-driver-image text-end text-md-center mt-2" >

                                    {data.img == null ?
                                      <i className="fa fa-user-circle  rgc-avatar-icon" aria-hidden="true"></i>
                                      :
                                      <Image src={ProfileUrl + data.img} className="rgc-avatar-driver" />

                                    }
                                  </Col>

                                  <Col xs={7} md={6} className="text-end mt-2">
                                    <div className="rgc-driver-btn rgc-orders-btn-edit"
                                      style={{ color: data.Color, background: data.Backcolor }} >
                                      <i className="fas fa-hourglass px-1"></i>
                                      {data.Stage_Tittle}
                                    </div>
                                  </Col>

                                  <Col xs={12} md={6} className="rgc-driver-txt text-end text-md-center">
                                    <div className="d-flex flex-column">
                                      <div>

                                        {data.deliveryId === 5 ?
                                          <span> ایستگاه: </span>
                                          :
                                          <span> راننده:</span>
                                        }


                                        <span>{data.FirstName}</span>
                                      </div>

                                      <div>
                                        {data.deliveryId === 5 ?
                                          <span> آدرس ایستگاه: </span>
                                          :
                                          <span>نوع وسیله نقلیه:</span>
                                        }

                                        <span>{data.Type_Device}{data.Address_station}</span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col xs={12} md={6} className="rgc-driver-txt text-end">

                                    <div className="d-flex flex-column">
                                      <div className="d-flex">
                                        <span> زمان حضور:</span>
                                        <span className="rgc-day">{data.Day}</span>
                                      </div>

                                      <div>
                                        <span>شماره تماس:</span>
                                        <span>{data.Mobile}</span>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col xs={12} className="rgc-weight py-2 text-center">
                                    <div className="d-flex justify-content-center rgc-contact">
                                      <a href={`tel:${data.Mobile}`}>
                                        <i className="fa fa-phone"></i>
                                      </a>
                                      <i className='fas fa-comments'></i>
                                      <i className="fa fa-map-marker-alt"></i>
                                    </div>
                                  </Col>

                                  <Col xs={12} className="rgc-driver-txt">
                                    <div className="d-flex justify-content-end">
                                      <div className="rgc-driver-txt-items">
                                        <span>وزن کل:</span>
                                        <span>{data.Weight} &nbsp;کیلوگرم</span>
                                      </div>

                                      <div>
                                        <span> مبلغ کل:</span>
                                        <span>{Intl.NumberFormat('en-US').format(data.Coint)} &nbsp; ریال</span>
                                      </div>
                                    </div>
                                  </Col>

                                </Row>
                              </Accordion.Header>
                              <Accordion.Body >
                                <hr />
                                <Row className="justify-content-start rgc-driver-content">
                                  {listOredr.map((data, index) => {
                                    return (
                                      <Col xs={12} lg={6} key={index} className="gx-md-5 gy-3">
                                        <Row className="rgc-driver-item g-0">
                                          <Col xs={2} className="text-center">
                                            <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                                          </Col>

                                          <Col xs={10} className="text-end">
                                            <span>{data.Type_Trash_Tittle}</span>
                                          </Col>

                                          <Col xs={6} className="text-center">
                                            <span>{data.Sub_Weight}</span><span>{data.Type_Weight_Title}</span>
                                          </Col>

                                          <Col xs={6} className="text-center">
                                            <span>{Intl.NumberFormat('en-US').format(data.Sub_Coint)}</span><span>ریال</span>
                                          </Col>
                                        </Row>
                                      </Col>
                                    )
                                  })}

                                  <div className="w-100"></div>


                                  <Col xs={6} md={4} className="text-center mt-3 m-auto">
                                    <Button className="rgc-driver-btn rgc-driver-btn-remove"
                                      onClick={() => handleShow(data.deliveryId, data.Order_Id)}
                                    >
                                      لغو سفارش
                                    </Button>
                                  </Col>

                                </Row>
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })}
                    </Accordion>
                  </Col>


                  <Col xs={12} className="sub-side">

                    <Row onClick={() => toggleHandler(1)} className="rgc-card g-0 rgc-order-card justify-content-center align-items-center">
                      <Col xs={3} className="rgc-item-img">
                        <img src={orders}
                          alt=""
                          className="rgc-img-dash" />
                      </Col>

                      <Col xs={7} className="rgc-item-txt text-end">
                        <h4> 1ثبت سفارش جدید</h4>
                        <span> سفارش خود را برای جمع آوری زباله ثبت کنید</span>
                      </Col>
                      <Col xs={2} className="rgc-item-icon me-auto">
                        <i className="fa fa-angle-left"></i>
                      </Col>
                    </Row>

                  </Col>

                  <Col xs={12} className="sub-side">
                    <NavLink to="/admin/mainaddress">
                      <Row className="rgc-card g-0 rgc-address-card justify-content-center align-items-center">
                        <Col xs={3} className="rgc-item-img">
                          <img src={address}
                            alt=""
                            className="rgc-img-dash" />
                        </Col>

                        <Col xs={7} className="rgc-item-txt text-end">
                          <h4> ثبت آدرس جدید</h4>
                          <span> آدرس خود را برای تحویل زباله انتخاب کنید</span>
                        </Col>
                        <Col xs={2} className="rgc-item-icon me-auto">
                          <i className="fa fa-angle-left"></i>
                        </Col>
                      </Row>
                    </NavLink>
                  </Col>

                  <Col xs={12} className="sub-side">
                    <NavLink to="../wallet">
                      <Row className="rgc-card g-0 rgc-score-card justify-content-center align-items-center">
                        <Col xs={3} className="rgc-item-img">
                          <img src={score}
                            alt=""
                            className="rgc-img-dash" />
                        </Col>

                        <Col xs={7} className="rgc-item-txt text-end">
                          <h4> انتقال مبلغ</h4>
                          <span> شما می توانید مبالغ خود را انتقال دهید</span>
                        </Col>
                        <Col xs={2} className="rgc-item-icon me-auto">
                          <i className="fa fa-angle-left"></i>
                        </Col>
                      </Row>
                    </NavLink>
                  </Col>


                </Row>
              </Col>
            </Row>

            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
              </Modal.Header>

              {/* Modal-Body */}
              {delivery === 5 &&
                <Modal.Body className="rgc-modal-content text-center">
                  <Image src={logo1} alt="logo" />
                  <Ripples className="rgc-ripple">
                    <Row
                      className={radioItem === 1 ?
                        "justify-content-center  rgc-modal-time rgc-station-select"
                        : "justify-content-center  rgc-modal-time"}
                    >
                      <Col xs={3} md={2}>
                        <div className="radio">
                          <input
                            type="radio"
                            value={1}
                            className="rgc-checkbox mt-2 me-2"
                            checked={radioItem === "1"}
                            onChange={(e) => RadioHandlerChange(e.target.value, ' برخورد نامناسب ایستگاه')}
                          />
                        </div>
                      </Col>

                      <Col xs={9} md={5} className="text-end rgc-day">
                        <span>برخورد نامناسب  ایستگاه</span>
                      </Col>

                    </Row>
                  </Ripples>

                  <Ripples className="rgc-ripple">
                    <Row
                      className={radioItem === 2 ?
                        "justify-content-center  rgc-modal-time rgc-station-select"
                        : "justify-content-center  rgc-modal-time"}
                    >
                      <Col xs={3} md={2}>
                        <div className="radio">
                          <input
                            type="radio"
                            value={2}
                            className="rgc-checkbox mt-2 me-2"
                            checked={radioItem === "2"}
                            onChange={(e) => RadioHandlerChange(e.target.value, 'دلایل دیگر')}
                          />
                        </div>
                      </Col>

                      <Col xs={9} md={5} className="text-end rgc-day">
                        <span> دلایل دیگر</span>
                      </Col>

                    </Row>
                  </Ripples>

                </Modal.Body>
              }

              {delivery === 3 &&
                <Modal.Body className="rgc-modal-content text-center">
                  <Image src={logo1} alt="logo" />
                  <Ripples className="rgc-ripple">
                    <Row
                      className={radioItem === 1 ?
                        "justify-content-center  rgc-modal-time rgc-station-select"
                        : "justify-content-center  rgc-modal-time"}
                    >
                      <Col xs={3} md={2}>
                        <div className="radio">
                          <input
                            type="radio"
                            value={1}
                            className="rgc-checkbox mt-2 me-2"
                            checked={radioItem === "1"}
                            onChange={(e) => RadioHandlerChange(e.target.value, 'منصرف شدم')}

                          />
                        </div>
                      </Col>

                      <Col xs={9} md={5} className="text-end rgc-day">
                        <span>منصرف شدم </span>
                      </Col>

                    </Row>
                  </Ripples>

                  <Ripples className="rgc-ripple">
                    <Row
                      className={radioItem === 2 ?
                        "justify-content-center  rgc-modal-time rgc-station-select"
                        : "justify-content-center  rgc-modal-time"}
                    >
                      <Col xs={3} md={2}>
                        <div className="radio">
                          <input
                            type="radio"
                            value={2}
                            className="rgc-checkbox mt-2 me-2"
                            checked={radioItem === "2"}
                            onChange={(e) => RadioHandlerChange(e.target.value, 'تاخیر راننده')}
                          />
                        </div>
                      </Col>

                      <Col xs={9} md={5} className="text-end rgc-day">
                        <span>تاخیر راننده</span>
                      </Col>

                    </Row>
                  </Ripples>

                  <Ripples className="rgc-ripple">
                    <Row
                      className={radioItem === 3 ?
                        "justify-content-center  rgc-modal-time rgc-station-select"
                        : "justify-content-center  rgc-modal-time"}
                    >
                      <Col xs={3} md={2}>
                        <div className="radio">
                          <input
                            type="radio"
                            value={3}
                            className="rgc-checkbox mt-2 me-2"
                            checked={radioItem === "3"}
                            onChange={(e) => RadioHandlerChange(e.target.value, 'حضور نداشتم')}
                          />
                        </div>
                      </Col>

                      <Col xs={9} md={5} className="text-end rgc-day">
                        <span> حضور نداشتم </span>
                      </Col>

                    </Row>
                  </Ripples>

                  <Ripples className="rgc-ripple">
                    <Row
                      className={radioItem === 4 ?
                        "justify-content-center rgc-modal-time rgc-station-select"
                        : "justify-content-center  rgc-modal-time"}
                    >
                      <Col xs={3} md={2}>
                        <div className="radio">
                          <input
                            type="radio"
                            value={4}
                            className="rgc-checkbox mt-2 me-2"
                            checked={radioItem === "4"}
                            onChange={(e) => RadioHandlerChange(e.target.value, 'دلایل دیگر')}
                          />
                        </div>
                      </Col>

                      <Col xs={9} md={5} className="text-end rgc-day">
                        <span>دلایل دیگر</span>
                      </Col>

                    </Row>
                  </Ripples>

                </Modal.Body>
              }

              {check === "1" &&
                <Modal.Body className="rgc-modal-content text-center">
                  <div className="d-flex flex-column justify-content-center">
                    <div className="text-center mb-2 rgc-title-modal">
                      <p>آیا از عملکرد راننده راضی هستید؟</p>
                    </div>
                    <div className="text-center">

                      <Rating onClick={handleRating} ratingValue={rating}
                        stars="6"
                        size={30}
                        transition={true}
                        fillColor="#fff200"
                        emptyColor="#cccccc"
                      />
                      
                    </div>
                  </div>


                </Modal.Body>
              }

              {check === "2" &&
                <Modal.Body className="rgc-modal-content text-center">
                  <Image src={logo1} alt="logo" />
                  <Row className="justify-content-center">
                    <Col xs={10} className="rgc-title-modal">
                      <p>آیا نسبت به اعتراض به این سفارش مطمئن هستید؟</p>
                    </Col>

                  </Row>
                </Modal.Body>
              }

              {/* Modal-Footer */}
              {delivery === 5 || delivery === 3 ?
                <Modal.Footer className="rgc-modal-button">
                  <Button onClick={() => deleteHandler(order)}>
                    بله</Button>
                  <Button onClick={handleClose}>
                    خیر
                  </Button>
                </Modal.Footer>
                :
                ""
              }
              {check === "1" &&
                <Modal.Footer className="rgc-modal-button">
                  <Button onClick={() => handleComment(rating)}>
                    ثبت نظر
                  </Button>

                  <Button onClick={() => handleComment(-1)}>
                    نظری ندارم
                  </Button>
                </Modal.Footer>
              }

              {check === "2" &&
                <Modal.Footer className="rgc-modal-button">
                  <Button onClick={handleProtest}>
                    بله
                  </Button>
                  <Button onClick={handleClose}>
                    خیر
                  </Button>
                </Modal.Footer>
              }

            </Modal>
          </Container>
          <OrderForm toggle={isOpen} address={address} toggleHandler1={toggleHandler} />
        </div>
      </main>
    </div>
  );
}

export default Dashboard;